<form [formGroup]="form" class="context-picker">
  @if (showCostCenter()) {
    <stena-select
      class="dense-3"
      formControlName="costCenterId"
      label="Cost center"
      [options]="costCenterOptions()"
    />
  }
  <stena-select
    class="dense-3"
    formControlName="monthId"
    label="Month"
    [options]="monthOptions()"
  />
  @if (showMode()) {
    <stena-select
      class="dense-3"
      formControlName="mode"
      label="Mode"
      [options]="modeOptions"
    />
  }
</form>
